"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/proposal_ring_box.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/proposal_ring_box.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/proposal_ring_box.png-wvc-sizes",
  alt: "Close up of the engagement ring in a velvet box"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/lily_emotional_proposal_reaction.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/lily_emotional_proposal_reaction.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/lily_emotional_proposal_reaction.png-wvc-sizes",
  alt: "Lily's emotional reaction during the proposal"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_kneeling_moment.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_kneeling_moment.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_kneeling_moment.png-wvc-sizes",
  alt: "Anthony on one knee in a scenic location"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/the_big_question_wide.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/the_big_question_wide.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/the_big_question_wide.png-wvc-sizes",
  alt: "Wide shot of the proposal moment under soft lighting"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/celebration_champagne_toast.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/celebration_champagne_toast.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/celebration_champagne_toast.png-wvc-sizes",
  alt: "The couple celebrating with a champagne toast"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/lily_hand_ring_detail.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/lily_hand_ring_detail.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/lily_hand_ring_detail.png-wvc-sizes",
  alt: "Detail shot of the ring on Lily's hand"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/proposal_scenery_sunset.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/proposal_scenery_sunset.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/proposal_scenery_sunset.png-wvc-sizes",
  alt: "The beautiful sunset backdrop of the proposal"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/couple_embrace_after.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/couple_embrace_after.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/couple_embrace_after.png-wvc-sizes",
  alt: "Anthony and Lily embracing after she said yes"
}];
export default function AmbitionInMotion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263261" id="the-proposal" className="dark bg-background text-foreground relative overflow-hidden py-16 md:py-24">
      {}
      <div className="pointer-events-none absolute inset-x-0 top-0 z-10 h-32 bg-gradient-to-b from-background to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-32 bg-gradient-to-t from-background to-transparent" />

      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="columns-1 gap-4 space-y-4 sm:columns-2 lg:columns-3 xl:columns-4">
          {galleryImages.map((image, i) => <div key={i} data-index={i} className="group relative break-inside-avoid overflow-hidden rounded-md bg-muted">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="w-full object-cover grayscale-[40%] transition-all duration-700 ease-in-out group-hover:scale-105 group-hover:grayscale-0 !h-[360px]" />
              {}
              <div className="pointer-events-none absolute inset-0 transition-opacity duration-500 group-hover:opacity-0" />
            </div>)}
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center p-4">
        <div ref={ref} className={`pointer-events-auto flex max-w-2xl flex-col items-center gap-6 rounded-md border border-white/5 bg-black/40 p-8 text-center shadow-xl backdrop-blur-sm transition-all duration-1000 md:p-12 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <div className="space-y-4">
            <h2 className="font-default text-3xl font-light uppercase tracking-widest text-white md:text-5xl lg:text-6xl">
              The Proposal
            </h2>
            <p className="mx-auto max-w-md text-sm font-default text-white/90 md:text-base">
              A timeless moment captured in the soft glow of dusk. The beginning of our forever, shared through the lens of love.
            </p>
          </div>

          <Button asChild size="lg" className="group mt-4 h-14 rounded-md bg-white px-8 text-base font-medium uppercase tracking-widest text-black shadow-md hover:bg-white/90">
            <Link to="/GalleryPage">
              View The Gallery
              <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}